<template>
  <div class="box">
    <div class="label">{{ label }}</div>
    <div class="inputrow" width="100">
      <span class="smart" @click="useSmart">{{ smart }}</span>
      <input
        v-model="garment"
        class="garment"
        type="number"
        @keypress="isNumber($event)"
      />
    </div>
    <div class="smart-measurements">S: {{ smartMeasurements }}</div>
  </div>
</template>
<style scoped>
.box {
  border-style: solid;
  border-color: black;
}

.label {
  font-size: 10;
  color: white;
  background-color: black;
  text-align: center;
}

.smart {
  float: left;
  width: 30%;
  vertical-align: middle;
  text-align: center;
  background-color: lightgray;
  cursor: pointer;
  border-bottom: 1px solid grey;
  min-height: 23px;
}

.garment {
  float: right;
  width: 70%;
  text-align: center;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.smart-measurements {
  background-color: lightgray;
  align-items: center;
  padding: 1px 10px;
}
</style>
<script>
export default {
  name: 'GarmentConfig',
  props: {
    label: {
      type: String,
      default: ''
    },
    smart: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ''
    },
    initGarment: {
      type: Number,
      default: 0
    },
    smartMeasurements: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      garment: 0
    }
  },
  watch: {
    garment() {
      this.$emit('config', { name: this.name, measure: this.garment })
    }
  },
  mounted() {
    this.garment = parseFloat(this.initGarment)
  },
  methods: {
    useSmart() {
      this.garment = parseFloat(this.smart)
    },
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// GarmentConfig.vue?1e6e184e